import type {CourseExpandedCommon} from '../../../api/course';
import type {EditionApiModel, ProgramApiModel} from '../../../api/program';
import type {Expand} from '../../../api/types';

import {courseExpandCommon} from '../../../api/course';
import {programStore} from '../../../api/program';
import {sortCoursesFn} from '../../../utils/entity/course';
import {logger} from '../../../utils/logger';

type Config = {
  coachId: string;
  programId: string;
};

type ExpandedEdition = EditionApiModel & {
  courses: CourseExpandedCommon[];
};

type ExpandedProgram = ProgramApiModel & {
  editions: ExpandedEdition[];
};

const editionExpand: Expand = {
  edition: [['course_ids', null, courseExpandCommon]],
};

const ALLOWED_STATUSES: CourseExpandedCommon['status'][] = [
  'planned',
  'ongoing',
];

export async function courseFetchClient({coachId, programId}: Config) {
  try {
    const program = (await programStore.client.fetch({
      _id: programId,
      coach_id: coachId,
      expand: {
        program: [['edition_ids', null, editionExpand]],
      },
    })) as ExpandedProgram;

    const {editions} = program;

    if (editions.length === 0) {
      return [];
    }

    return editions
      .filter(({status}) => status === 'active')
      .reduce((courses, edition) => [...courses, ...edition.courses], [])
      .filter(({status}) => ALLOWED_STATUSES.includes(status))
      .sort(sortCoursesFn);
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
